import React from 'react';
import cn from "classnames";
import styles from "../../lib/global.css";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

/**
 * 栏目卡片
 * @param props
 * @returns {*}
 * @constructor
 */
const Card = props => {
    return (
        <div className={cn(styles.antCol, styles.antCol24)}>
            <div
                className={cn(styles.antPageHeader, styles.antPageHeaderGhost)}
                style={{paddingLeft: 0, paddingRight: 0}}
            >
                <div className={styles.antPageHeaderHeading}>
                    <div className={styles.antPageHeaderHeadingLeft}>
                        <span className={styles.antPageHeaderHeadingTitle} title={props.title}>{props.title}</span>
                        {props.buttons}
                        <span>{props.subTitle}</span>
                    </div>
                    <span className={styles.antPageHeaderHeadingExtra}>
                        {props.moreURL ? (
                            <Link key="more" className={styles.link} to={props.moreURL}>{window.L('teach.card.more')} &gt; </Link>
                        ) : null}
                    </span>
                </div>
            </div>
            <div className={props.style?'':styles.siteCardWrapper}>
                {props.children}
            </div>
        </div>
    );
};

Card.propTypes = {
    title: PropTypes.string, //栏目标题
    subTitle: PropTypes.string, //栏目子标题
    buttons: PropTypes.element, //标题旁边的按钮
    moreURL: PropTypes.string, //更多链接
};

export default Card;
